import { render, staticRenderFns } from "./ForwardedMessageRow.vue?vue&type=template&id=58b4882d&scoped=true&"
import script from "./ForwardedMessageRow.vue?vue&type=script&lang=js&"
export * from "./ForwardedMessageRow.vue?vue&type=script&lang=js&"
import style0 from "./ForwardedMessageRow.vue?vue&type=style&index=0&id=58b4882d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b4882d",
  null
  
)

export default component.exports